import GetAppIcon from '@mui/icons-material/GetApp';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import * as FileSaver from 'file-saver';
import React from 'react';
import * as XLSX from 'xlsx';

function CsvButton({
  getCsvData,
  fileName,
  headers,
}: {
  getCsvData: () => any;
  fileName: string;
  headers: any[];
}) {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  return (
    <Tooltip title="Export to CSV">
      <IconButton
        onClick={async () => {
          const csvData = getCsvData();
          const workSheetData = XLSX.utils.json_to_sheet(
            csvData,
            headers ? { header: headers } : {},
          );
          const workBookData = {
            Sheets: {
              data: workSheetData,
            },
            SheetNames: ['data'],
          };
          const excelBuffer = XLSX.write(workBookData, {
            bookType: 'xlsx',
            type: 'array',
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, fileName + fileExtension);
        }}
        aria-label="export">
        <GetAppIcon />
      </IconButton>
    </Tooltip>
  );
}

export default CsvButton;
